export default __webpack_public_path__ + "static/media/density-snow.2ac35591.png";